allow-visible-on-all-workspaces:
  title: 跨桌面可见性
  description: 允许窗口在所有虚拟桌面中可见，仅限 macOS。
spotlight:
  errors:
    unknown: 未知错误
    prefix: '出错啦：{message}'
    shortcutRegistrationFailed: '出错啦：快捷键注册失败'
pages:
  modules:
    mcp-server:
      description: 连接与管理 MCP 服务器和工具
      title: MCP 服务器
  system:
    sections:
      section:
        window-shortcuts:
          title: 键盘快捷键
    window-shortcuts:
      description: 修改窗口快捷方式
      title: 窗口快捷方式
      empty: 未设置
      spotlight:
        title: Spotlight 快捷键
        description: 点击快捷键后按下新的快捷键，按 Esc 取消。
      actions:
        recording: 请按键
        reset: 重置
      errors:
        load: 无法加载快捷键
        conflict: 该快捷键已被占用
        failed: 快捷键更新失败
        requiresModifier: 请至少使用 Cmd、Ctrl、Alt 或 Super 中的一个修饰键。
      toggle-move:
        label: 切换移动状态
      toggle-resize:
        label: 调整大小
      toggle-ignore-mouse-event:
        label: 忽略鼠标事件
      press-keys: 请按下按键...
    developer:
      sections:
        section:
          use-window-mouse:
            title: useElectronWindowMouse
            description: 测试 Electron 窗口鼠标位置
devtools:
  title: 开发者选项
  pages:
    context-flow:
      title: Context Flow
    editor:
      title: AIRI 编辑器
      description: 打开独立的 AIRI 编辑器窗口
      button: 打开编辑器
    lag-visualizer:
      title: Lag 可视化
    performance-visualizer:
      title: 性能可视化
      description: 检查实时性能指标和运行时诊断数据
      controls:
        enable-all:
          label: 启用所有可用指标
          description: 启用当前浏览器支持的所有指标。
        start-recording: 开始录制
        stop-recording: 停止录制（{seconds} 秒）
        export-last-recording: 导出上次录制
      metrics:
        fps:
          label: FPS
          description: 最近 10 秒内的每秒帧数。
        frame-duration:
          label: 帧时间（毫秒）
          description: 最近 10 秒内动画帧之间的时间。
        long-task:
          label: 长任务
          description: 耗时至少 50 毫秒的主线程任务。
          unsupported: 当前浏览器不提供长任务计时。
        memory:
          label: JS 堆（MB）
          description: Chromium performance.memory API 提供的 JavaScript 堆用量。
          unsupported: 当前浏览器不提供 JavaScript 堆用量。
      recording:
        title: 上次录制
        duration: 时长 {duration} 毫秒
        limit: 录制会在 60 秒后停止。
      overlay:
        title: 性能
        move: 移动性能浮窗
        reset-position: 重置浮窗位置
        record: 录制
        stop: 停止
        export: 导出上次录制
        average: 平均
    markdown-stress:
      title: Markdown 压力测试
      description: 用大量聊天负载来测试 Markdown 的解析和渲染能力
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: 小组件调用
screen-capture:
  permissions-prompt:
    title: 屏幕捕获
    description: 要捕获屏幕或窗口，需要屏幕和系统音频录制权限。
    open-preferences: 打开系统偏好设置
    dismiss: 取消
    instructions:
      step-1: 打开「系统首选项」，从侧边栏选择「隐私与安全」。
      step-2: 在「屏幕和系统音频录制」和「系统音频录制」部分中，开启 AIRI 的开关。
      step-2-note: 如果没有列出 AIRI，请通过单击「+」按钮和从应用程序文件夹中选择 AIRI 来手动添加。
